/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState} from 'react';
// material
import {Group, TextField, TextAreaField, RadioField, SelectField, CheckboxField} from '@insticator/insticator-ui'; // iui-material
import DropDownItem from './dropdownitem/dropdownitem';
// styles
import injectSheet from 'react-jss';
import styles from './autofilltext_styles';


/* ========== ~~~~~~~~~~ AUTO FILL TEXT ~~~~~~~~~~ ========== */
const AutoCompleteTextField = injectSheet(styles)(props => {

    const [filteredList, setFilteredList] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [active, setActive] = useState(false);

    const handleBlur = (e) => {
        props.handleBlur(e.target.value);
    }

    const handleChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        let filteredItems = [];
        if (value.length > 0) {
            let initialItems = props.list.map(item => ({name: item.name, value: item.value.toLowerCase()}));
            filteredItems = initialItems.filter(item => item.value.indexOf(value.toLowerCase()) >= 0);
        }

        setFilteredList(filteredItems)
        setActive(!!(filteredItems.length > 0))
        setSearchTerm(value)
    }

    const handleSelect = item => {
        setActive(false);
        setSearchTerm('');
        props.handleSelect(item.value);
    };

    const renderItems = () => (
        filteredList.map((item, i) => {
            return <DropDownItem handleSelect={handleSelect} searchTerm={searchTerm} name={item.name}
                                 value={item.value} itemSelected={filteredList[i] === item} key={i} index={i}
                                 item={item}/>
        })
    )

    // Returns the component specified by props.type, will need to constantly update imports with any new field types
    const newField = () => {
        let ComponentType = TextField;
        switch (props.type) {
            case 'text':
            case 'color':
            case 'date':
            case 'datetime-local':
            case 'email':
            case 'password':
            case 'month':
            case 'number':
            case 'range':
            case 'search':
            case 'tel':
            case 'time':
            case 'url':
            case 'week':
                ComponentType = TextField;
                break;
            case 'textarea':
                ComponentType = TextAreaField;
                break;
            case 'select':
                ComponentType = SelectField;
                break;
            case 'checkbox':
                ComponentType = CheckboxField;
                break;
            case 'radio':
                ComponentType = RadioField;
                break;
            default:
                break;
        }
        return (
            <ComponentType
                type={props.type}
                name={props.name}
                placeholder={props.placeholder}
                label={props.label}
                info={props.info}
                handleFocus={props.handleFocus}
                value={props.value}
                handleBlur={handleBlur}
                handleKeyDown={props.handleKeyDown}
                handleChange={handleChange}
                valid={props.valid}
                required={props.required}
            />
        );
    };


    return (
        <Group name={`menuItems ${props.classes.autotextfill}`}>
            {newField()}
            <Group name={`items active-${active}`}>
                {renderItems()}
            </Group>
        </Group>
    );

});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AutoCompleteTextField;
